export default "__VITE_ASSET__DRLyNjjp__"